import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import * as yup from 'yup';

/** Common phone number validation schema */
export const phoneNumberSchema = yup
  .string()
  .matches(/^\+7[0-9]{3}[0-9]{7}$/i, DtoMessageEnum.INCORRECT_PHONE);
